import { Box, useTheme } from "@mui/system";
import GlobalSearchMeetingsView from "./GlobalSearchMeetingsView";
import { Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import arrowBackSvg from "../../assets/common/arrow-back.svg";

const GlobalSearchMeetingsPage = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const storedData = JSON.parse(sessionStorage.getItem('searchData') || '{}');
  const { searchData, meetingsCount, search } = storedData;
  const handleBack = () => {
    const previousPage = sessionStorage.getItem('previousPage');
    if (previousPage) {
      navigate(previousPage);
    } else {

      navigate('/home');
    }
  };
  
  return (
    <Box className="meetingsContent w-full">
      <Box
        sx={{
          height: "100%",
          padding: "15px",
          [theme.breakpoints.down("lg")]: {
            padding: "10px",
          },
          border: `2px solid ${theme.palette.secondary.main}`,
          borderRadius: "22px",
          background: "#FFFFFF",
        }}
      >
        <Box className="flex flex-row justify-start items-center gap-2 cursor-pointer"
          onClick={handleBack}>
          <img src={arrowBackSvg} />
          <Typography variant="h3" >{`Interactions search results for - "${search}"`}</Typography>
        </Box>
        <Typography variant="body2" sx={{ display: "flex", justifyContent: "end", marginTop: "-25px", marginRight: "10px" }}>{meetingsCount} Interactions Found</Typography>
        <Box className="flex flex-col justify-start" sx={{ marginTop: "10px" }}>
          <GlobalSearchMeetingsView
            searchData={searchData}
          />
        </Box>
      </Box>
    </Box>

  );
};
export default GlobalSearchMeetingsPage;
